<particle-workflow-wizard *ngIf="workflowId && workflowId.length" [workflowId]="workflowId"
                          [apiEndpointKey]="apiEndpointKey"
                          (GridCellValueChanged)="onGridCellValueChange($event)">

</particle-workflow-wizard>
